import React, { useCallback, useMemo, useState } from 'react';
import QuizContent from '../shared/QuizContent';
import VideoCarousel from '../shared/VideoCarousel';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useDesign } from '../../contexts/DesignContext';
import { useGrowthBookValues } from '../../contexts/GrowthBookContext';
import { CDN_URL } from '../../constants';
import { trackStep6 } from '../../utils/analytics';

const Step4_5 = ({ onAnswer, onPrevious, selections, isTransitioning }) => {
  const { t } = useTranslation();
  const { isNewDesign } = useDesign();
  const location = useLocation();

  const selectedStyle = location.pathname.includes('/create-ai-hentai')
    ? 'Anime'
    : location.pathname.includes('/create-ai-porn')
    ? 'Realistic'
    : selections?.welcome || 'Realistic';

  const isHalloween = !!location.pathname.includes('/halloween');

  const { content: gbContent } = useGrowthBookValues();

  const formatKinkTitle = (text) => {
    if (text === text.toUpperCase()) {
      return text;
    }
    return text.replace(/([a-z])([A-Z])/g, '$1 $2');
  };

  const kinkItems = useMemo(() => {
    const videos = [];
    let idCounter = 0;

    Object.keys(gbContent).forEach((key) => {
      if (key.startsWith('kinks_')) {
        const parts = key.replace('kinks_', '').split('_');
        if (parts.length === 2) {
          const [style, type] = parts;

          if (
            (selectedStyle === 'Anime' && style.toLowerCase() === 'anime') ||
            (selectedStyle === 'Realistic' &&
              style.toLowerCase() === 'realistic')
          ) {
            idCounter++;
            videos.push({
              id: idCounter,
              value: idCounter,
              videoSrc: `${CDN_URL}/${gbContent[key]}`,
              title: formatKinkTitle(type),
            });
          }
        }
      }
    });

    return videos;
  }, [gbContent, selectedStyle]);

  const [selectedKink, setSelectedKink] = useState(null);

  const handleKinkSelect = useCallback((value) => {
    setSelectedKink(value);
  }, []);

  const handlePrevious = useCallback(() => {
    if (isTransitioning) return;
    onPrevious();
  }, [onPrevious]);

  const handleContinue = useCallback(() => {
    if (isTransitioning || !selectedKink) return;

    const selectedVideo = kinkItems.find((item) => item.value === selectedKink);

    trackStep6(selectedVideo?.title || selectedKink);

    onAnswer('step4_5', {
      kink: selectedKink,
      kinkVideoSrc: selectedVideo?.videoSrc,
      kinkTitle: selectedVideo?.title,
    });
  }, [selectedKink, onAnswer, isTransitioning, kinkItems]);

  const title = isHalloween || isNewDesign ? (
    <>
      {t('choose')}
      <span className="specialText"> {t('what_shes_into')}</span>
    </>
  ) : (
    t('choose_your_kinks')
  );

  return (
    <div className={`quizContentWrapper ${isTransitioning ? 'no-click' : ''}`}>
      <QuizContent className="step4-5-design">
        <VideoCarousel
          items={kinkItems}
          title={title}
          onSelect={handleKinkSelect}
          isTransitioning={isTransitioning}
          imageContainerClass="kinks-video-container"
          forceShowVideos={true}
        />

        <div className="navigation-wrapper step4-5-navigation-wrapper">
          <button
            className="previous-button"
            onClick={handlePrevious}
            disabled={isTransitioning}
          >
            {t('previous')}
          </button>
          <button
            className="continue-button"
            onClick={handleContinue}
            disabled={!selectedKink || isTransitioning}
          >
            {t('next')}
          </button>
        </div>
      </QuizContent>
    </div>
  );
};

export default Step4_5;
